<div class="app-claim-charger-dialog">
  <div class="header">
    <h3>Claim this charger</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <ngx-simplebar [options]="{ autoHide: true }" style="max-height: 560px;">
    <div class="content">
      <app-alert [successMessage]="successMessage" [errorMessage]="errorMessage"></app-alert>

      @if (step() === 'form') {
        <div class="claim-context">
          <mat-icon>info</mat-icon>
          <span>
            You're claiming <strong>{{ props.stationName || 'this site' }}</strong>.
            Reports and status route to you once verified.
          </span>
        </div>

        <form [formGroup]="claimForm" (ngSubmit)="submitClaim()">
          <mat-form-field appearance="outline">
            <mat-label>Your role</mat-label>
            <mat-select formControlName="role">
              <mat-option
                [value]="role.key"
                *ngFor="let role of ROLE_LABELS | keyvalue: keepOriginalOrder"
              >
                {{ role.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Work email</mat-label>
            <input
              matInput
              type="email"
              formControlName="contactEmail"
              placeholder="you@company.com"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Phone (optional)</mat-label>
            <input matInput type="tel" formControlName="contactPhone" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>How can you prove ownership? (optional)</mat-label>
            <textarea
              matInput
              rows="3"
              formControlName="evidenceNote"
              placeholder="Used only if we need a manual review"
            ></textarea>
          </mat-form-field>

          <div class="actions">
            <button
              [disabled]="isLoading() || claimForm.invalid"
              mat-flat-button
              type="submit"
            >
              Send code
            </button>
          </div>
        </form>
      } @else if (step() === 'otp') {
        <p class="description">
          Enter the 6-digit code we sent to <strong>{{ contactEmail }}</strong>.
        </p>

        <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
          <mat-form-field appearance="outline">
            <mat-label>Verification code</mat-label>
            <input
              matInput
              inputmode="numeric"
              maxlength="6"
              formControlName="code"
              placeholder="000000"
            />
          </mat-form-field>

          <div class="link-row">
            <button type="button" mat-button (click)="resendOtp()">Resend code</button>
            <button type="button" mat-button (click)="backToForm()">
              Use a different email
            </button>
          </div>

          <div class="actions">
            <button
              [disabled]="isLoading() || otpForm.invalid"
              mat-flat-button
              type="submit"
            >
              Verify &amp; claim
            </button>
          </div>
        </form>
      } @else {
        <div class="done">
          <mat-icon class="done-icon">check_circle</mat-icon>
          @if (isVerified) {
            <h4>Charger claimed</h4>
            <p>
              Code confirmed and your email domain matched, so you're verified.
              Reports for this site now route to you.
            </p>
          } @else {
            <h4>Claim submitted for review</h4>
            <p>
              Your code confirmed your inbox. A GitCharger admin will review your
              claim and confirm within 1 business day.
            </p>
          }
          <div class="actions">
            <button mat-flat-button (click)="close()">Done</button>
          </div>
        </div>
      }
    </div>
  </ngx-simplebar>
</div>
